module.exports = __webpack_public_path__ + "img/users.0b31706a.svg";